import { useState } from 'react';

/**
 * Hook customizado para gerenciar modais com ação de PDF
 * Integra com o DefaultModal para fornecer funcionalidade de confirmação antes de abrir PDFs
 */
const usePdfModal = () => {
  const [modalData, setModalData] = useState({
    show: false,
    type: '',
    message: '',
    onConfirm: null,
  });

  /**
   * Mostra um modal simples (sucesso, erro, informação)
   */
  const showDefaultModal = (type, message) => {
    setModalData({
      show: true,
      type: type,
      message: message,
      onConfirm: null,
    });
  };

  /**
   * Mostra um modal de sucesso com ação de abrir PDF
   */
  const showModalWithPdfAction = (message, pdfData) => {
    setModalData({
      show: true,
      type: 'success',
      message: message,
      onConfirm: () => {
        const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
        setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
        closeModal();
      },
    });
  };

  /**
   * Mostra um modal de sucesso com ação customizada
   */
  const showModalWithCustomAction = (type, message, onConfirm) => {
    setModalData({
      show: true,
      type: type,
      message: message,
      onConfirm: () => {
        if (onConfirm) onConfirm();
        closeModal();
      },
    });
  };

  /**
   * Fecha o modal
   */
  const closeModal = () => {
    setModalData(prevModalData => ({
      ...prevModalData,
      show: false,
      onConfirm: null,
    }));
  };

  return {
    modalData,
    showDefaultModal,
    showModalWithPdfAction,
    showModalWithCustomAction,
    closeModal,
  };
};

export default usePdfModal;
